import { Action } from '@ngrx/store';

export enum AdvancedSOSActionTypes {
  REQUEST_SOS = '[Cyclops Advanced SOS] Request SOS',
  REQUEST_SOS_SUCCESS = '[Cyclops Advanced SOS] Request SOS Success',
  REQUEST_SOS_FAILED = '[Cyclops Advanced SOS] Request SOS Failed',
  CLOSE_REQUEST = '[Cyclops Advanced SOS] Close Request',
  CLOSE_REQUEST_SUCCESS = '[Cyclops Advanced SOS] Close Request Success',
  CLOSE_REQUEST_FAILED = '[Cyclops Advanced SOS] Close Request Failed',
  RESPOND_SOS = '[Cyclops Advanced SOS] Respond SOS',
  RESPOND_SOS_SUCCESS = '[Cyclops Advanced SOS] Respond SOS Success',
  RESPOND_SOS_FAILED = '[Cyclops Advanced SOS] Respond SOS Failed',
  GET_ADVANCED_SOS_REQUESTS_RESPONDS = '[Cyclops Advanced SOS] Get Advanced SOS Requests Responds',
  GET_ADVANCED_SOS_REQUESTS_RESPONDS_SUCCESS = '[Cyclops Advanced SOS] Get Advanced SOS Requests Responds Success',
  GET_ADVANCED_SOS_REQUESTS_RESPONDS_FAILED = '[Cyclops Advanced SOS] Get Advanced SOS Requests Responds Failed',
  STORE_ROUTE_DATA = '[Cyclops Advanced SOS] Store Route Data',
  STORE_ROUTE_DATA_SUCCESS = '[Cyclops Advanced SOS] Store Route Data Success',
  STORE_ROUTE_DATA_FAILED = '[Cyclops Advanced SOS] Store Route Data Failed',
  RESET_STATE = '[Cyclops Advanced SOS] Reset State',

  GET_ADVANCED_SOS_UPDATES = '[Cyclops Advanced SOS] Get Advanced SOS Updates',
  GET_ADVANCED_SOS_UPDATES_SUCCESS = '[Cyclops Advanced SOS] Get Advanced SOS Updates Success',
  GET_ADVANCED_SOS_UPDATES_FAILED = '[Cyclops Advanced SOS] Get Advanced SOS Updates Failed',

  SAVE_SOS_DATA = '[Cyclops Advanced SOS] Save Sos Data',
}
export class ResetState implements Action {
  readonly type = AdvancedSOSActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class SaveSosData implements Action {
  readonly type = AdvancedSOSActionTypes.SAVE_SOS_DATA;
  constructor(public payload: any) {}
}
export class RequestSOS implements Action {
  readonly type = AdvancedSOSActionTypes.REQUEST_SOS;
  constructor(public payload: any) {}
}
export class RequestSOSFailed implements Action {
  readonly type = AdvancedSOSActionTypes.REQUEST_SOS_FAILED;
  constructor(public payload: any) {}
}
export class RequestSOSSuccess implements Action {
  readonly type = AdvancedSOSActionTypes.REQUEST_SOS_SUCCESS;
  constructor(public payload: any) {}
}
export class CloseRequest implements Action {
  readonly type = AdvancedSOSActionTypes.CLOSE_REQUEST;
  constructor(public payload: any) {}
}
export class CloseRequestFailed implements Action {
  readonly type = AdvancedSOSActionTypes.CLOSE_REQUEST_FAILED;
  constructor(public payload: any) {}
}
export class CloseRequestSuccess implements Action {
  readonly type = AdvancedSOSActionTypes.CLOSE_REQUEST_SUCCESS;
  constructor(public payload: any) {}
}
export class RespondSOS implements Action {
  readonly type = AdvancedSOSActionTypes.RESPOND_SOS;
  constructor(public payload: any) {}
}
export class RespondSOSSuccess implements Action {
  readonly type = AdvancedSOSActionTypes.RESPOND_SOS_SUCCESS;
  constructor(public payload: any) {}
}
export class RespondSOSFailed implements Action {
  readonly type = AdvancedSOSActionTypes.RESPOND_SOS_FAILED;
  constructor(public payload: any) {}
}
export class GetAdvancedSOSRequestsResponds implements Action {
  readonly type = AdvancedSOSActionTypes.GET_ADVANCED_SOS_REQUESTS_RESPONDS;
  constructor(public payload: any) {}
}
export class GetAdvancedSOSRequestsRespondsFailed implements Action {
  readonly type =
    AdvancedSOSActionTypes.GET_ADVANCED_SOS_REQUESTS_RESPONDS_FAILED;
  constructor(public payload: any) {}
}
export class GetAdvancedSOSRequestsRespondsSuccess implements Action {
  readonly type =
    AdvancedSOSActionTypes.GET_ADVANCED_SOS_REQUESTS_RESPONDS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetAdvancedSOSUpdates implements Action {
  readonly type = AdvancedSOSActionTypes.GET_ADVANCED_SOS_UPDATES;
  constructor(public payload: any) {}
}
export class GetAdvancedSOSUpdatesFailed implements Action {
  readonly type = AdvancedSOSActionTypes.GET_ADVANCED_SOS_UPDATES_FAILED;
  constructor(public payload: any) {}
}
export class GetAdvancedSOSUpdatesSuccess implements Action {
  readonly type = AdvancedSOSActionTypes.GET_ADVANCED_SOS_UPDATES_SUCCESS;
  constructor(public payload: any) {}
}
export class StoreUserRouteData implements Action {
  readonly type = AdvancedSOSActionTypes.STORE_ROUTE_DATA;
  constructor(public payload: any) {}
}
export class StoreUserRouteDataSuccess implements Action {
  readonly type = AdvancedSOSActionTypes.STORE_ROUTE_DATA_SUCCESS;
  constructor(public payload: any) {}
}
export class StoreUserRouteDataFailed implements Action {
  readonly type = AdvancedSOSActionTypes.STORE_ROUTE_DATA_FAILED;
  constructor(public payload: any) {}
}

export type CyclopsAdvancedSOSActionUnion =
  | ResetState
  | RequestSOS
  | RequestSOSFailed
  | RequestSOSSuccess
  | RespondSOS
  | RespondSOSSuccess
  | RespondSOSFailed
  | GetAdvancedSOSRequestsResponds
  | GetAdvancedSOSRequestsRespondsFailed
  | GetAdvancedSOSRequestsRespondsSuccess
  | GetAdvancedSOSUpdates
  | GetAdvancedSOSUpdatesSuccess
  | GetAdvancedSOSUpdatesFailed
  | StoreUserRouteData
  | StoreUserRouteDataSuccess
  | StoreUserRouteDataFailed
  | CloseRequest
  | CloseRequestSuccess
  | CloseRequestFailed
  | SaveSosData;
